// extracted by mini-css-extract-plugin
export var carousel = "Carousel-module--carousel--MCc6t";
export var content = "Carousel-module--content--eY9zK";
export var currentPage = "Carousel-module--currentPage--M0QmU";
export var disabled = "Carousel-module--disabled--mwYgg";
export var pagination = "Carousel-module--pagination--liY8j";
export var seta = "Carousel-module--seta--6g9eO";